import { render, staticRenderFns } from "./ModbusRegisterForm.vue?vue&type=template&id=10f30fe7"
import script from "./ModbusRegisterForm.vue?vue&type=script&lang=js"
export * from "./ModbusRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports